import api from './api.js'

// token请求
const client = process.env.AUTH_CLIENT
export function token(params) {
    return api.post('/service-auth/oauth/token', {}, { params: client });
}

// 获取字典列表
export function getDictionaryItem(params) {
    return api.get('/service-center/api/v1/dictionary/item', params);
}


// 方案banner接口
// uuid id
export function getBannerList(params) {
    return api.get('/service-center/api/v1/dictionary/item', params);
}

// 解决方案类别
// name 名称
// survival 状态(ENABLE:启用;DISABLE:停用;VERIFY:验证中;)
// currentPage 起始页
// pageSize 分页条数
export function getProgramList(params) {
    return api.get('/resource-portal/api/v1/solution/program/proTable', params);
}

// 解决方案列表
// name 名称
// status 状态(HIDE:隐藏;DRAFT:草稿;RELEASE:发布;)
// programUuid 类别id
// programName 类别名称
// currentPage 起始页
// pageSize 分页条数
export function getSolutionList(params) {
    return api.get('/resource-portal/api/v1/solution/item/proTable', params);
}

// 解决方案详情数据
// uuid id
export function getSolutionDetail(uuid) {
    return api.get('/resource-portal/api/v1/solution/item/portal/' + uuid);
}

// 园区生态
// parkName 园区名称
// addr 地址
// area 区域
// peoNum
// outPutValue
// capacity
// sorter
// current 起始页
// pageSize 分页条数
export function getParkList(params) {
    return api.get('/resource-portal/api/v1/park/park/manage/proTable', params);
}

// 新闻资讯
// sorter 排序
// programUuid 类别id
// status 状态
// current 起始页
// pageSize 分页条数
// origin 来源 PORTAL:平台，PARK:'园区'
// parkSource 园区主键
export function getNewsItemList(params) {
    return api.get('/resource-portal/api/v1/news/item/text/query', params);
}

// 新闻详情
// uuid 新闻主键
// origin 来源 PORTAL:平台，PARK:'园区'
// parkSource 园区主键
export function getNewsItemInfo(params) {
    return api.get('/resource-portal/api/v1/news/item/text/info', params);
}

// 获取园区详情
// uuid 园区Id
export function getParkDetail(uuid) {
    return api.get('/resource-portal/api/v1/park/park/manage/' + uuid);
}

// 重点企业
// enterpriseName 企业名称
// addr 地址
// parkName 学院名称
// isScale 是否规上企业
// parkId 园区ID
// url 链接
// sorter 排序
// current 起始页
// pageSize 分页条数
export function getEnterpriseMangeList(params) {
    return api.get('/resource-portal/api/v1/park/enterprise/manage/query', params);
}

// 类型信息
// ignoreUuid
// parkSource
export function getProgramInfo(params) {
    return api.get('/resource-portal/api/v1/news/program/tree', params);
}

// 类型信息
// parentCode(父级编码)
export function getProgramChildList(params) {
    return api.get('/resource-portal/api/v1/news/program/list', params);
}

export function getItemList(params) {
    return api.get('/resource-portal/api/v1/solution/item/query', params);
}

export function getIndexParkList(params) {
    return api.get('/resource-portal/api/v1/park/park/manage/getIndexParkList', params);
}

export function getIndexNewTextList(params) {
    return api.get('/resource-portal/api/v1/news/item/text/getIndexNewTextList', params);
}



export function getParkEnterpriseList(params) {
    return api.get('/resource-portal/api/v1/park/enterprise/manage/getIndexParkEnterpriseList', params);
}



export function getParkAddrList(params) {
    return api.get('/resource-portal/api/v1/park/park/manage/getParkAddrList', params);
}


export function getIndexDictionaryData(params) {
    return api.get('/service-center/api/v1/dictionary/item', params);
    // return api.get('/service-center/api/v1/dictionary/item/getIndexData',params);
}

// 园区详情

export function getParkDetailData(params) {
    return api.get('/resource-portal/api/v1/park/park/manage/getParkDetailData', params);
}

export function getNewsItemTextList(params) {
    return api.get('/resource-portal/api/v1/news/item/text/query', params);
}

export function getNewsProgramTreeList(params) {
    return api.get('/resource-portal/api/v1/news/program/tree/list', params);
}

// 新闻详情数据
// uuid id
export function getNewDetail(params) {
    return api.get('/resource-portal/api/v1/news/item/text/info', params);
}

export function getNewProgramDetail(uuid) {
    return api.get('/resource-portal/api/v1/news/program/' + uuid);
}

export function getSolutionProgramList(params) {
    return api.get('/resource-portal/api/v1/solution/program/list', params);
}


// uuid id
export function getSolutionItemList(params) {
    return api.get('/resource-portal/api/v1/solution/item/query', params);
}

export function saveSolutionConsult(params) {
    return api.post('/resource-portal/api/v1/solution/consult/save', params);
}

export function getIndexSolutionData() {
    return api.get('/resource-portal/api/v1/solution/program/getIndexSolutionData');
}

export function getParkEnterpriseDetail(uuid) {
    return api.get('/resource-portal/api/v1/park/enterprise/manage/' + uuid);
}

// 账号密码登录
export function getUserAndPassLogin(params) {
    return api.post('/service-auth/oauth/login', params);
}
// 短信登录
export function getMessagesLogin(params) {
    return api.post('/service-auth/sms/login', params);
}
// 获取安全校验码
export function getSecurityCode(params) {
    return api.get('/service-auth/api/v2/validate/code', params);
}
// 注册接口
export function getRegistered(params) {
    return api.post('/service-auth/api/v2/register', params);
}
// 是否注册过
export function getRegisteredOr(params) {
    return api.get('/service-center/api/v1/user/exists', params);
}
// 点击获取短息
export function getSmscode(params) {
    return api.get('/service-auth/api/v2/sms/code', params);
}
// 注销用户
export function cancellationUser(params) {
    return api.deleteApi('/service-center/api/v1/user/cancel', params);
}
// 注销用户时的订单确认
export function orderExists() {
    return api.get('/resource-order/api/v1/order/base/doing/exists');
}
// 校验用户名是否存在
export function existsUserName(params) {
    return api.get('/service-center/api/v1/security/account/exists', params);
}
// 忘记密码
export function editPassword(params) {
    return api.put('/service-center/api/v2/security/account/password', params);
}
// 获取当前用户登录信息
export function getNewcurrent(params) {
    return api.get('/service-center/api/v1/user/current', params);
}
// 获取当前用户实名认证信息
export function getIdentity(params) {
    return api.get('/service-center/api/v1/identity/personal/current', params);
}
// 修改当前用户登录信息
export function editUserInfo(params) {
    return api.post('/service-center/api/v1/user/current', params);
}
//获取园区vr分组集合
export function getVrGroupList(uuid) {
    return api.get('/resource-portal/api/v1/park/vrResource/' + uuid);
}

//获取软件集合
export function getSoftwareList(params) {
    return api.get('/resource-portal/api/v1/software/manage/query', params);
}
//获取软件供应商集合
export function getSoftwareSupplierList(params) {
    return api.get('/resource-portal/api/v1/software/supplier/manage/query', params);
}

//获取软件类型集合
export function getSoftwareTypeList(params) {
    return api.get('/resource-portal/api/v1/software/type/manage/query', params);
}


//获取软件详情集合
export function getSoftwareDetail(uuid) {
    return api.get('/resource-portal/api/v1/software/manage/' + uuid);
}

//收藏软件
export function saveCollection(params) {
    return api.post('/resource-portal/api/v1/software/manage/saveCollection', params);
}

//查看该软件是否被该用户收藏
export function findIsCollectionByUserAndSoftId(params) {
    return api.get('/resource-portal/api/v1/software/manage/findIsCollectionByUserAndSoftId', params);
}


//获取软件详情集合
export function delCollection(params) {
    return api.post('/resource-portal/api/v1/software/manage/delCollection', params);
}


//修改浏览量+1
export function updateSoftwarePageViews(param) {
    return api.post('/resource-portal/api/v1/software/manage/updateSoftwarePageViews', param);
}


//获取软件详情页面的推荐软件
export function getSoftwareDetailViewRecommend(params) {
    return api.get('/resource-portal/api/v1/software/manage/getSoftwareDetailViewRecommend', params);
}

//获取软件近半年销量
export function getSoftwareSalesByHalfYear(params) {
    return api.get('/resource-order/api/v1/software/orderDetail/manage/getSoftwareSalesByHalfYear', params);
}

//保存订单
export function saveSaftwareOrder(params) {
    return api.post('/resource-order/api/v1/software/orderDetail/manage', params);
}



// 新闻资讯
// sorter 排序
// programUuid 类别id
// status 状态
// current 起始页
// pageSize 分页条数
// origin 来源 PORTAL:平台，PARK:'园区'
// parkSource 园区主键
export function queryNewText(params) {
    return api.get('/resource-portal/api/v1/news/item/text/queryNewText', params);
}

//实名认证
// 根据用户获取认证信息
export function getCredentials() {
    return api.get('/service-center/api/v1/identity/personal/current');
}
//提交认证信息
export function submitCredentials(params) {
    return api.post('/service-center/api/v1/identity/personal', params);
}
//更新认证信息
export function amendCredentials(params, uuid) {
    return api.put('/service-center/api/v1/identity/personal/' + uuid, params);
}

//企业认证
// 根据用户获取企业认证信息
export function getEnterpriseCredentials() {
    return api.get('/service-center/api/v1/identity/enterprise/current');
}
//提交企业认证信息
export function submitEnterpriseCredentials(params) {
    return api.post('/service-center/api/v1/identity/enterprise', params);
}
//更新企业认证信息
export function amendEnterpriseCredentials(params, uuid) {
    return api.put('/service-center/api/v1/identity/enterprise/' + uuid, params);
}

// 安全设置
// 修改密码
export function changePassword(params) {
    return api.post('/service-center/api/v1/user/password', params);
}

//收藏新闻
export function saveNewsCollection(params) {
    return api.post('/resource-portal/api/v1/news/collection/save', params);
}

//取消收藏新闻
export function deleteNewsCollection(params) {
    return api.post('/resource-portal/api/v1/news/collection/deleteNewsCollection', params);
}

//点赞新闻
export function saveNewsFabulous(params) {
    return api.post('/resource-portal/api/v1/news/fabulous/save', params);
}

//取消点赞新闻
export function deleteNewsFabulous(params) {
    return api.post('/resource-portal/api/v1/news/fabulous/deleteNewsFabulous', params);
}


// 身份证信息识别
export function getIdCardInformation(url) {
    return api.get('/service-center/api/v1/identity/ocr/idCard', url);
}
// 企业信息识别
export function getLicenseInformation(url) {
    return api.get('/service-center/api/v1/identity/ocr/license', url);
}
//保存应用
export function saveApplication(params) {
    return api.post('/resource-portal/api/v1/software/application/manage', params);
}
//获取应用
export function getApplicationList(params) {
    return api.get('/resource-portal/api/v1/software/application/manage/query', params);
}
//获取应用列表
export function getAllApplicationList(params) {
    return api.get('/resource-portal/api/v1/software/application/manage/list', params);
}

//删除应用
export function delSoftwareApplicationByUUIDList(params) {
    return api.post('/resource-portal/api/v1/software/application/manage/delSoftwareApplicationByUUIDList', params);
}

//获取软件收藏
export function getSoftwareCollection(params) {
    return api.get('/resource-portal/api/v1/software/manage/getSoftwareCollection', params);
}

//删除收藏
export function delSpftwareCollection(params) {
    return api.get('/resource-portal/api/v1/software/manage/delSpftwareCollection', params);
}

//获取用户列表
export function getEnterpriseUserList(params) {
    return api.get('/service-center/api/v1/user/staff/pagination', params);
}

//保存用户
export function saveMemberUser(params) {
    return api.post('/service-center/api/v1/user/staff', params);
}

//一下 俩接口暂时不用
//停用用户
export function disableUser(uuid) {
    return api.post('/service-center/api/v1/user/batch/disable?uuid=' + uuid);
}
//启用用户
export function enableUser(uuid) {
    return api.post('/service-center/api/v1/user/batch/enable?uuid=' + uuid);
}


export function getOrganizationDeptTree(params) {
    return api.get('/service-center/api/v1/organization/dept/tree/list', params);
}

export function saveOrganizationDept(params) {
    return api.post('/service-center/api/v1/organization/dept', params);
}

export function getOrganizationDept(params) {
    return api.get('/service-center/api/v1/organization/dept/deptList', params);
}

export function deleteOrganizationDept(uuid) {
    return api.deleteUrl('/service-center/api/v1/organization/dept/' + uuid);
}

// 客户案列
export function findSoftwareCase(params) {
    return api.get('/resource-portal/api/v1/software/case/manage/list', params);
}

// 服务商入驻
export function saveProvidersInfo(params) {
    return api.post('/resource-print/api/v1/shopper/providers', params);
}

export function getDictionaryGroup(params) {
    return api.get('/service-center/api/v1/dictionary/group/list', params);
}

export function findProvidersInfo() {
    return api.get('/resource-print/api/v1/shopper/providers/findProvidersInfo');
}

// 发布需求
export function addDemand(params) {
    return api.post('/resource-design/api/v1/demand', params);
}

// 需求列表
export function queryDemandList(params) {
    return api.get('/resource-design/api/v1/demand/query', params);
}

// 需求列表
export function demandList(params) {
    return api.get('/resource-design/api/v1/demand/list', params);
}

// 设计师入驻
export function addDesigner(params) {
    return api.post('/resource-design/api/v1/designer/designerIn', params);
}

// 设计师需求报价
export function addDesignerOffer(params) {
    return api.post('/resource-design/api/v1/designer/offer', params);
}
// 查询设计师是否对当前需求有报价
export function hasDesignerOffer(uuid) {
    return api.post('/resource-design/api/v1/designer/isOffered/' + uuid);
}
// 设计师列表
export function designerList(params) {
    return api.get('/resource-design/api/v3/designer/list', params);
}

// 分页获取设计师列表
export function designerListByPage(params) {
    return api.get('/resource-design/api/v3/designer/query', params);
}

// 分页获取需求列表
export function demandListByPage(params) {
    return api.get('/resource-design/api/v1/demand/query', params);
}
// 分页获取相似需求列表
export function similarDemandListByPage(params) {
    return api.get('/resource-design/api/v1/demand/similarQuery', params);
}
// 根据用户ID获取设计师信息
export function designerByUserId(userId) {
    return api.get('/resource-design/api/v1/designer/getByUserId/' + userId);
}
// 判断用户是否能进行设计师入驻
export function couldIn() {
    return api.get('/resource-design/api/v1/designer/webCouldIn');
}
// 获取设计师详情
export function designerDetail(id) {
    return api.get('/resource-design/api/v1/designer/' + id);
}
// 获取设计师详情
export function designerViewDetail(id) {
    return api.get('/resource-design/api/v1/designer/view/' + id);
}
// 获取需求详情
export function demandDetail(id) {
    return api.get('/resource-design/api/v1/demand/' + id);
}

// 查询首页材料库
export function getMaterialList(params) {
    return api.get('/resource-print/api/v1/material/manager/nose/query', params);
}

// 查询热门服务
export function getServiceabilityList(params) {
    return api.get('/resource-print/api/v1/serviceability/nose/query', params);
}

// 查询服务详情
export function getServiceabilityDetail(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getServiceabilityDetail', params);
}

// 随机切换服务
export function getNewServiceability() {
    return api.get('/resource-print/api/v1/serviceability/nose/getNewServiceability');
}

// 查询推荐服务商
export function getShopperList(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/query', params);
}

export function getPrintEnterPriseList(params) {
    return api.get('/resource-print/api/v1/print/enterPrise/list', params);
}

// 查询推荐服务商
export function getRecommendList() {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getRecommendList');
}

// 服务商详情页
export function getProvidersSettledInfo(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getProvidersSettledDetail', params);
}

export function getEnterPriseInfo(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getEnterPriseInfo', params);
}

//成果展示
export function getPresentationList(params) {
    return api.get('/resource-print/api/v1/presentation/nose/query', params);
}

// 查询模型
export function queryModelList(params) {
    return api.get('/resource-design/api/v1/design/model/query', params);
}

// 查询模型
export function getModelList(params) {
    return api.get('/resource-design/api/v1/design/model/list', params);
}
// 查询模型详情
export function getModelDetail(params) {
    return api.get(`/resource-design/api/v1/design/model/${params.uuid}`);
}

// 查询成品
export function queryProductList(params) {
    return api.get('/resource-design/api/v1/design/product/query', params);
}
// 查询成品详情
export function getProductDetail(id) {
    return api.get(`/resource-design/api/v1/design/product/` + id);
}
// 修改访问量
export function addProductAccessNum(id) {
    return api.get(`/resource-design/api/v1/design/product/accessNum/` + id);
}
// 模型订单添加接口
export function addOrder(params) {
    return api.post('/resource-order/api/v1/order/model/save', params);
}
// 模型订单查询接口
export function getModelOrderList(params) {
    return api.get('/resource-order/api/v1/order/model/query', params);
}
// 服务订单添加接口
export function addServiceOrder(params) {
    return api.post('/resource-order/api/v1/order/service/save', params);
}

export function getExamineStatusInfo(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getExamineStatus', params);
}

//
export function getManagerProvidersInfo(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getManagerProvidersInfo', params);
}


export function getPrintProvidersList(params) {
    return api.get('/resource-print/api/v1/shopper/providers/nose/getPrintProvidersList', params);
}

export function getModelLandDetail(params) {
    return api.get('/resource-print/api/v1/material/manager/nose/getModelLandDetail', params);
}

export function savePrintOrder(params) {
    return api.post('/resource-print/api/v1/buyer/print/order', params);
}

export function findBuyerPrintOrderDetail(params) {
    return api.get('/resource-print/api/v1/buyer/print/order/findBuyerPrintOrderDetail', params);
}

export function getLogisticsInfo(params) {
    return api.get(`/resource-print/api/v1/logistics/${params.uuid}`);
}

export function getAddressList(params) {
    return api.get('/service-center/api/v1/address/query', params);
}

export function saveAddressInfo(params) {
    return api.post('/service-center/api/v1/address', params);
}

export function getAddressDetail(params) {
    return api.get(`/service-center/api/v1/address/${params.uuid}`);
}

export function editAddressInfo(params) {
    return api.post(`/service-center/api/v1/address/${params.uuid}`, params);
}

export function getDictionaryGroupByKey(params) {
    return api.get(`/service-center/api/v1/dictionary/group/${params.uuid}`);
}

// 发票抬头列表展示
export function invoiceTitleList(params) {
    return api.get('/service-center/api/v1/invoice/title/user', params);
}

// 新增发票抬头信息
export function saveInvoiceInfo(params) {
    return api.post('/service-center/api/v1/invoice/title', params);
}

// 修改发票抬头信息
export function editInvoiceInfo(params) {
    return api.put(`/service-center/api/v1/invoice/title/${params.uuid}`, params);
}

// 查询发票抬头详情
export function findInvoiceInfo(params) {
    return api.get(`/service-center/api/v1/invoice/title/${params.uuid}`);
}

// 保存打印订单到order里面
export function saveOrderPrint(params) {
    return api.post('/resource-order/api/v1/order/print/save', params);
}

// 查询打印订单数据
export function getOrderPrint(params) {
    return api.get('/resource-order/api/v1/order/print/getOrderPrint', params);
}

export function saveServiceOrder(params) {
    return api.get('/resource-print/api/v1/buyer/service/order', params);
}

// 查询当前内容是否被收藏或关注
export function hasLiked(uuid) {
    return api.get('/resource-design/api/v1/designer/like/' + uuid);
}

// 收藏或关注当前内容
export function like(params) {
    return api.post('/resource-design/api/v1/designer/like', params);
}




// 获取融云token
export function getRongCloudToken(params) {
    return api.get('/service-center/api/v1/rongcloud/getToken', params);
}

//（融云用）根据目标id获取用户或者企业管理员
export function getRongCloudUser(uuid) {
    return api.get('/service-center/api/v1/user/rongCloud/' + uuid);
}

// 查询用户
export function getUserInfo(uuid) {
    return api.get('/service-center/api/v1/user/' + uuid);
}

// 查询用户是否收藏服务
export function isCollection(params) {
    return api.get('/resource-print/api/v1/collection/info/isCollection', params);
}

// 添加收藏
export function saveServiceCollection(params) {
    return api.post('/resource-print/api/v1/collection/info', params);
}

// 取消收藏
export function removeCollection(params) {
    return api.get('/resource-print/api/v1/collection/info/removeCollection', params);
}

// 查询用户是否关注
export function isFollow(params) {
    return api.get('/resource-print/api/v1/follow/info/isFollow', params);
}

// 添加关注
export function saveFollow(params) {
    return api.post('/resource-print/api/v1/follow/info', params);
}

// 取消关注
export function removeFollow(params) {
    return api.get('/resource-print/api/v1/follow/info/removeFollow', params);
}

// 保存在线咨询
export function saveConsult(params) {
    return api.post('/resource-message/api/v1/consult/save', params);
}

export function saveVisitorLog(params) {
    return api.post('/resource-message/api/v1/visitor/log/save', params);
}

// 分页获取评价列表
export function getEvaluationList(params) {
    return api.get(`/resource-order/api/v1/order/evaluation/adminQuery`, params);
}

//获取评论标签信息
export function getTagsByGoodsId(params) {
    return api.get(`/resource-order/api/v1/order/evaluation/getTagsByGoodsId`, params);
}

// 获取全部评价列表
export function getAllEvaluationList(params) {
    return api.get(`/resource-order/api/v1/order/evaluation/list`, params);
}


// 查询当前用户所有上传过的数据
export function getHistoryList(params) {
    return api.get('/resource-print/api/v1/buyer/print/technology/proTable', params);
}

// 删除
export function deleteHistory(params) {
    return api.get('/resource-print/api/v1/buyer/print/technology/deleteHistoryData', params);
}

// 获取服务成交量
export function getServiceOrderCompleteCount(params) {
    return api.get('/resource-order/api/v1/order/service/getServiceOrderCompleteCount', params);
}

// 获取评分
export function getEvaluationNumber(params) {
    return api.get('/resource-order/api/v1/order/evaluation/getEvaluationNumber', params);
}

// 保存开票信息
export function saveIssueInvoiceByUuid(params) {
    return api.post('/resource-order/api/v1/issue/invoice/save', params);
}

//收藏模型添加数量
export function saveModelCollection(id) {
    return api.get('/resource-design/api/v1/design/model/collectionNum/' + id);
}
//点赞模型
export function saveDesignerFabulous(params) {
    return api.post('/resource-design/api/v1/design/fabulous/save', params);
}

//取消点赞模型
export function deleteDesignerFabulous(params) {
    return api.post('/resource-design/api/v1/design/fabulous/deleteDesignerFabulous', params);
}

//点赞模型
export function saveDemandFabulous(params) {
    return api.post('/resource-design/api/v1/demand/fabulous/save', params);
}

//取消点赞模型
export function deleteDemandFabulous(params) {
    return api.post('/resource-design/api/v1/demand/fabulous/deleteDemandFabulous', params);
}

// 根据数据字典id查询材料类型信息
export function findTypeListByGroupUuid(params) {
    return api.get('/resource-order/api/v1/material/type/findTypeListByGroupUuid', params);
}

// 根据主键查询材料类型信息
export function get(params) {
    return api.get('/resource-order/api/v1/material/type/get', params);
}

// 获取文档信息
export function getInfoByWordNo(params) {
    return api.get('/resource-portal/api/v1/wordInfo/getInfoByWordNo', params);
}

// 获取设计师banner
export function getDesignBanner(params) {
    return api.get('/resource-design/api/v1/banner/list', params);
}

// 分页获取个人中心软件应用列表
export function querySoftwareOrderDetailList(params) {
    return api.get('/resource-order/api/v1/software/orderDetail/manage/query', params);
}
// 获取全部个人中心软件应用列表
export function queryAllSoftwareOrderDetailList(params) {
    return api.get('/resource-order/api/v1/software/orderDetail/manage/list', params);
}


// 获取活动列表
export function getActivityList(params) {
    return api.get('/resource-activity/api/v1/activity/manage/query', params);
}

// 获取活动详情信息
export function getActivityDetail(params) {
    return api.get('/resource-activity/api/v1/activity/manage/getDetail', params);
}

export function getActivityDetailInfo(params) {
    return api.get('/resource-activity/api/v1/activity/manage/getDetailInfo', params);
}

// 报名
export function saveActivitySign(params) {
    return api.post('/resource-activity/api/v1/activity/sign', params);
}

export function isSign(params) {
    return api.get('/resource-activity/api/v1/activity/sign/isSign', params);
}

// 查询活动类别
export function getActivityTypeList(params) {
    return api.get("/resource-activity/api/v1/activity/manage/getActivityTypeList", params);
}

// 查询活动赛道
export function getActivityWayList(params) {
    return api.get('/resource-activity/api/v1/activity/way/list', params);
}

// 上传作品
export function uploadWorks(params) {
    return api.post(`/resource-activity/api/v1/activity/works/${params.activityUuid}`, params);
}

// 查询作品
export function isUploadWorks(params) {
    return api.get('/resource-activity/api/v1/activity/works/isUploadWorks', params);
}

// 查询详情
export function getViewUploadWorks(activityUuid) {
    return api.get(`/resource-activity/api/v1/activity/works/viewDetail/${activityUuid}`);
}

// 更新列表
export function updateUploadWorks(params) {
    return api.put(`/resource-activity/api/v1/activity/works/${params.uuid}`, params);
}

// 查询作品审核列表
export function getWorksList(params) {
    return api.get('/resource-activity/api/v1/activity/works/query', params);
}

// 查询作品审核列表
export function getWorksDetail(uuid) {
    return api.get(`/resource-activity/api/v1/activity/works/view/${uuid}`);
}

// 作品投票
export function saveWorksVote(worksUuid) {
    return api.post(`/resource-activity/api/v1/activity/works/vote/${worksUuid}`);
}

// 作品评论
export function saveEvaluateList(params) {
    return api.post('/resource-activity/api/v1/activity/works/evaluate', params);
}

// 评论列表
export function getEvaluateList(params) {
    return api.get('/resource-activity/api/v1/activity/works/evaluate/query', params);
}

// 点赞评论
export function saveThumb(worksUuid) {
    return api.post(`/resource-activity/api/v1/activity/works/thumb/${worksUuid}`);
}

// 是否点赞
export function isExistsThumb(worksUuid) {
    return api.get(`/resource-activity/api/v1/activity/works/thumb/exists/${worksUuid}`);
}

// 是否点赞
export function deleteThumb(worksUuid) {
    return api.deleteUrl(`/resource-activity/api/v1/activity/works/thumb/${worksUuid}`);
}

// 获取设计师banner
export function getDesignLevel(params) {
    return api.get('/resource-design/api/v1/designer/level/getDesignerLevel', params);
}

// 商城接口
// 获取商城列表
export function getShopList(params) {
    return api.get('/resource-print/api/v1/goods/view/query', params);
}

export function getGoodsDetail(params) {
    return api.get('/resource-print/api/v1/goods/view/detail', params);
}

export function getOrderGoodsDetail(params) {
    return api.get('/resource-print/api/v1/goods/view/orderDetail', params);
}

export function getGoodsDetailList(params) {
    return api.get('/resource-print/api/v1/goods/view/detailList', params);
}

// 获取商品分类树
export function getShopCategoryList(params) {
    return api.get(`/resource-print/api/v1/shop/category/getShopCategoryList`, params);
}

// 获取推荐商品
export function getRelateRecommendList(params) {
    return api.get('/resource-print/api/v1/goods/view/relateRecommend', params);
}

// 随机获取活动作品
export function getRandList(params) {
    return api.get('/resource-activity/api/v1/activity/works/getRandList', params);
}


// 查询用户权限
export function getStoreInfo(uuid) {
    return api.get(`/resource-print/api/v1/store/${uuid}`);
}

// 查询用户权限
export function getStoreInfoByEnterPriseUuid(params) {
    return api.get('/resource-print/api/v1/store/view', params);
}

// 店铺详情信息
export function getInfoByEnterPriseUuid(params) {
    return api.get('/resource-print/api/v1/print/enterPrise/getInfoByEnterPriseUuid', params);
}

// 相关店铺
export function findStoreInfoList(params) {
    return api.get('/resource-print/api/v1/shop/settled/findShopSettledList', params);
}

// 入驻信息
export function findShopSettledInfo(params) {
    return api.get('/resource-print/api/v1/shop/settled/findShopSettledInfo', params);
}

// 商家信息
export function findRecommendList(params) {
    return api.get('resource-print/api/v1/shopper/settled/front/query', params);
}

export function getShopRecommendList() {
    return api.get('resource-print/api/v1/goods/view/recommend');
}

export function getShopRecommendDetail(uuid) {
    return api.get(`/resource-print/api/v1/goods/view/recommend/${uuid}`);
}

export function typeTree(params) {
    return api.get(`/resource-print/api/v1/shop/category/typetree`, params);
}

// 保存商城订单
export function saveShopOrder(params) {
    return api.post('/resource-order/api/v1/order/shop/save', params);
}


// 保存商城订单
export function saveShopCar(params) {
    return api.post('/resource-order/api/v1/order/shop/car/save', params);
}

// 查询购物车数量
export function getShopCarNumber() {
    return api.get('/resource-order/api/v1/order/shop/car/getShopCarNumber');
}

// 查询购物车数量
export function getShopCarList(params) {
    return api.get('/resource-order/api/v1/order/shop/car/list', params);
}

// 查询购物车数量
export function deleteShopCarInfo(params) {
    return api.deleteUrl('/resource-order/api/v1/order/shop/car/deleteShopCarInfo', params);
}


// 单独上传图片接口
export function single(params) {
    return api.post('/service-center/upload/file/single', params);
}

// 计算运费
export function calculateTransaction(params) {
    return api.get('/resource-print/api/v1/goods/view/countTransportationInfo', params);
}

// 保存购物车
export function saveShopCarNum(params) {
    return api.get('/resource-order/api/v1/order/shop/car/saveShopCarNum', params);
}

// 验证企业名称是否存在，不存在：true
export function validName(params) {
    return api.get('/service-center/api/v1/identity/enterprise/validName', params);
}

// 验证统一社会信用编码是否存在，不存在：true
export function validCode(params) {
    return api.get('/service-center/api/v1/identity/enterprise/validCode', params);
}

// 打包下载模型文件
export function downloadFile(uuid) {
    return api.getFile('/resource-design/api/v1/design/model/downloadFile/' + uuid);
}

// 生成二维码接口
export function generateQrCode(parmas) {
    return api.get('/service-auth/api/v1/qr/code', parmas);
}
// 获取扫码结果接口
export function scanCodeInfo(parmas) {
    return api.get('/service-auth/api/v1/qr/code/info', parmas);
}
// 微信授权登录
export function weChatLogin(parmas) {
    return api.get('/service-auth/api/v1/social/wechat', parmas);
}
// 微信登录账号绑定接口
export function weChatBind(parmas) {
    return api.post('/service-auth/api/v1/social/wechat/bind', parmas);
}
// 查询当前需求参与报价的设计师
export function findDemandOfferList(params) {
    return api.get('/resource-design/api/v1/demand/findDemandOffer', params);
}

// 成交记录
export function orderRecordList(params) {
    return api.get('/resource-order/api/v1/order/record/query', params);
}
// 设计订单列表
export function designOrderList(params) {
    return api.get('/resource-order/api/v1/order/design/list', params);
}
// 获取平台商品分类树
export function webStoreTree(params) {
    return api.get(`/resource-print/api/v1/shop/category/webStoreTree`, params);
}

// 主页设置模板
export function pageSettingInfo(userId) {
    return api.get(`/resource-print/api/v1/pageSetting/pageSettingInfoByUserId/${userId}`);
}

// 查询用户入网申请
export function merchantCurrent() {
    return api.get('/resource-pay/api/v1/yop/merchant/current');
}
// 积分活动主页
export function activityInfo(uuid) {
    return api.get(`/resource-order/api/v1/order/activities/${uuid}`);
}

// 积分活动商品列表
export function activityShopList(param) {
    return api.get('/resource-order/api/v1/order/activityGoodsInfo/query', param);
}
//用户积分接口
export function currentPoints() {
    return api.get('/service-center/api/v1/user/sign/points/current');
}
//查询当前用户即将过期积分
export function expirePoints() {
    return api.get('/service-center/api/v1/user/sign/points/expire');
}
//校验用户账号是否存在
export function existsUser(param) {
    return api.get('/service-center/api/v1/user/staff/exists', param);
}
//校验用户账号积分是否可以兑换当前商品
export function isUserPointsIsEnough(param) {
    return api.get('/resource-print/api/v1/goods/view/isUserPointsIsEnough', param);
}
// 查询模型文件列表
export function getModelFileList(param) {
    return api.get('/resource-order/api/v1/order/model/getModelFileList', param);
}
// 模型活动的上传作品
export function matchList(param) {
    return api.get('/resource-activity/api/v1/activity/match/list', param);
}

// 企业简介
export function getQualifications(uuid) {
    return api.get(`/service-center/api/v1/organization/enterprise/${uuid}`);
    // return api.get(`/service-center/api/v1/organization/dept/${uuid}`);
}



// WEBPACK FOOTER //
// ./src/utils/interface.js